import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Loader from '@/Loader';
import App from './App';
import router from './router';
import store from './store';

import '@/styles/style.scss';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component('Loader', Loader);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
